var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"app",style:({
    '--bg-color': _vm.getThemeVar('--bg-color'),
    '--bg-color2': _vm.getThemeVar('--bg-color2'),
    '--menu-text-color': _vm.getThemeVar('--menu-text-color'),
    '--border-color': _vm.getThemeVar('--border-color'),
    '--hover-bg-color': _vm.getThemeVar('--hover-bg-color'),
    '--label-color': _vm.getThemeVar('--label-color'),
    '--switcher-bold-color': _vm.getThemeVar('--switcher-bold-color'),
    '--chat-hover': _vm.getThemeVar('--chat-hover'),
    '--list-color': _vm.getThemeVar('--list-color'),
    '--bg-color3': _vm.getThemeVar('--bg-color3'),
    '--hover-newbg-color': _vm.getThemeVar('--hover-newbg-color'),
    '--pdf-modal-color': _vm.getThemeVar('--pdf-modal-color'),
    '--pdf-file-color': _vm.getThemeVar('--pdf-file-color'),
  })},[_c('vue-progress-bar'),_c('div',{staticClass:"app__wrapper"},[_c('nav-aside'),_c('div',{staticClass:"app__block"},[_c('notifications'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1),_c('talkdesk'),_c('info-btn')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }